import React from 'react';
import * as PropTypes from 'prop-types';
import {
  ElementWrapper,
  ValueWrapper,
  ValueText,
  Icon,
  LabelText,
} from './elements';
import Cnt10 from '../Cnt10';

function Lab115(props) {
  return (
    <ElementWrapper
      id={props.id}
      theme={props.theme}
      onClick={props.onClick}
      className={props.className}
    >
      <LabelText theme={props.theme}>{props.label}</LabelText>
      <ValueWrapper>
        <Icon icon={props.icon} style={{ color: props.iconColor }} />
        <ValueText as={'span'}>
          {typeof props.value === 'number' ? (
            <Cnt10
              decimals={props.decimals}
              animate={!props.noAnimation}
              locale={props.locale}
            >
              {props.value}
            </Cnt10>
          ) : (
            props.value
          )}
        </ValueText>
      </ValueWrapper>
    </ElementWrapper>
  );
}

Lab115.propTypes = {
  className: PropTypes.string,
  decimals: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  id: PropTypes.string,
  icon: PropTypes.string,
  iconColor: PropTypes.string,
  label: PropTypes.string,
  noAnimation: PropTypes.bool,
  onClick: PropTypes.func,
  theme: PropTypes.oneOf(['dark', 'light']),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  locale: PropTypes.string.isRequired,
};

export default Lab115;
